/**
 * Tooltip Component
 * Theme-aware tooltip that respects dark/light mode
 */

import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Tooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const { getThemeClasses } = useTheme();
    const themeClasses = getThemeClasses();

    return (
        <div className="relative inline-flex items-center">
            <div
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                className="cursor-help"
            >
                {children || <HelpCircle size={14} className={`${themeClasses.textMuted} hover:text-blue-400 transition-colors`} />}
            </div>
            
            {isVisible && (
                <div className="absolute z-50 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64">
                    <div className="bg-gray-900 dark:bg-gray-800 border border-gray-700 dark:border-gray-600 rounded-lg shadow-xl p-3 backdrop-blur-sm">
                        <p className="text-xs text-gray-100 dark:text-gray-200 leading-relaxed">
                            {text}
                        </p>
                        {/* Arrow */}
                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                            <div className="w-2 h-2 bg-gray-900 dark:bg-gray-800 border-gray-700 dark:border-gray-600 border-b border-r transform rotate-45"></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Tooltip;
